import { PropsWithChildren, ReactNode } from 'react';
import styled, { CSSProperties } from 'styled-components';

import { Vertical } from 'atoms/layout/flex';
import { BlockHeader } from 'components/rivals/branded/BlockHeader';

const Root = styled(Vertical)`
  --color: var(--c-neutral-300);
  --bg: var(--c-neutral-100);

  overflow: hidden;
  isolation: isolate;
  position: relative;
  height: 168px;
  color: var(--c-neutral-1000);
  border-radius: calc(var(--double-unit) + 2px);
  justify-content: space-between;

  border: 2px solid transparent;
  background:
    linear-gradient(to bottom, var(--bg), var(--bg)) padding-box,
    var(--color) border-box;
`;
const Content = styled.div`
  padding: 0 var(--double-unit) var(--double-unit);
`;

type Props = {
  title?: ReactNode;
  subtitle?: ReactNode;
  color?: string;
  borderColor?: string;
  bg?: string;
  extra?: ReactNode;
  className?: string;
};
export const Block = ({
  title,
  subtitle,
  color,
  borderColor,
  bg,
  extra,
  children,
  className,
}: PropsWithChildren<Props>) => {
  return (
    <Root
      style={
        {
          '--color': borderColor || color,
          '--bg': bg,
        } as CSSProperties
      }
      className={className}
    >
      <BlockHeader
        withSubtitle={!!subtitle}
        color={color}
        colorOpacity={1}
        leftNode={
          <Vertical gap={0.5}>
            <div>{title}</div>
            <div>{subtitle}</div>
          </Vertical>
        }
        rightNode={extra}
      />
      <Content>{children}</Content>
    </Root>
  );
};
